"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyTitle = void 0;
exports.yesNoOptions = yesNoOptions;
exports.emptyTitle = { en: '', fr: '' };
function yesNoOptions() {
    return [
        { id: 'yes', text: { fr: 'Oui', en: 'Yes' } },
        { id: 'no', text: { fr: 'Non', en: 'No' } },
    ];
}
